import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { TranslocoModule } from '@jsverse/transloco'
import { ButtonModule } from 'primeng/button'
import { RadioButtonModule } from 'primeng/radiobutton'
import { DynamicDialogRef } from 'primeng/dynamicdialog'

export type BundleType = 'tabs' | 'group'

/** Chooser for what a new assistance bundle becomes: independent tabs or a group session; closes with the chosen {@link BundleType}. */
@Component({
  selector: 'app-bundle-type-dialog',
  templateUrl: './bundle-type-dialog.component.html',
  styleUrls: ['./bundle-type-dialog.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, TranslocoModule, ButtonModule, RadioButtonModule],
})
export class BundleTypeDialogComponent {
  private readonly dialogRef = inject(DynamicDialogRef)

  protected readonly options: { value: BundleType; titleKey: string; descriptionKey: string; usageKey: string }[] = [
    {
      value: 'tabs',
      titleKey: 'GROUP_SESSION_EDITOR.TABS',
      descriptionKey: 'GROUP_SESSION_EDITOR.TABS_DESCRIPTION',
      usageKey: 'GROUP_SESSION_EDITOR.TABS_USAGE',
    },
    {
      value: 'group',
      titleKey: 'GROUP_SESSION_EDITOR.GROUP_SESSION',
      descriptionKey: 'GROUP_SESSION_EDITOR.GROUP_SESSION_DESCRIPTION',
      usageKey: 'GROUP_SESSION_EDITOR.GROUP_SESSION_USAGE',
    },
  ]

  protected selected: BundleType = 'tabs'

  protected confirm(): void {
    this.dialogRef.close(this.selected)
  }

  protected cancel(): void {
    this.dialogRef.close()
  }
}
